const SKU_SEPARATOR_PATTERN = /[,|;\/\s]+/;

function pdpOnetimeVolumeRate(mainElement, quantity) {
  var qty = parseInt(quantity, 10) || 1;
  var root = mainElement && mainElement.querySelector && mainElement.querySelector('[data-pdp-qty-selectors]');
  if (root) {
    var active =
      root.querySelector('.pdp-qty-opt.is-active') ||
      root.querySelector('.pdp-qty-opt[data-qty="' + qty + '"]');
    if (active && active.hasAttribute('data-onetime-disc')) {
      return parseFloat(active.getAttribute('data-onetime-disc') || '0') || 0;
    }
  }
  if (qty >= 3) return 0.2;
  if (qty >= 2) return 0.1;
  return 0;
}

function pdpOnetimeVolumeTotal(unitCents, quantity, mainElement) {
  var qty = parseInt(quantity, 10) || 1;
  var total = unitCents * qty;
  var rate = pdpOnetimeVolumeRate(mainElement, qty);
  if (rate <= 0) return total;
  return total - Math.floor(total * rate);
}

function pdpSelectedQuantity(mainElement, multiplyQuantity) {
  var root = mainElement && mainElement.querySelector && mainElement.querySelector('[data-pdp-qty-selectors]');
  if (root) {
    var active = root.querySelector('.pdp-qty-opt.is-active');
    var n = active ? parseInt(active.getAttribute('data-qty'), 10) : 0;
    if (n > 0) return n;
  }
  if (multiplyQuantity === false) return 1;
  return parseInt(mainElement && mainElement.getQuantity && mainElement.getQuantity(), 10) || 1;
}

if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      
      // Optimize product data parsing with error handling
      const productJsonElement = this.querySelector('[type="application/json"][data-product-json]');
      if (productJsonElement) {
        try {
          this.productData = JSON.parse(productJsonElement.textContent);
        } catch (e) {
          console.error('Failed to parse product data:', e);
          this.productData = { variants: [], options: [] };
        }
      } else {
        this.productData = { variants: [], options: [] };
      }
      
      // Cache DOM elements for better performance
      this.variantsElement = this.querySelector('product-variants');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.badgePerBottle = this.querySelector('.per-bottle-value');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      
      this.optionValues = {};
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options.filter(x=>(requiredOptionsSettingUnique.indexOf(x)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && this.getOptionValues(x).length>1);
      this.originalRequiredOptions = [...this.requiredOptions];
      
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      
      // Use event delegation for better performance
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));

      var variantContentJsonEl = this.querySelector('[data-variant-content-json]');
      if (variantContentJsonEl) {
        try {
          this.variantContentByVariantId = JSON.parse(variantContentJsonEl.textContent);
        } catch (error) {
          this.variantContentByVariantId = null;
        }
        this.addEventListener('variantChange', this.onVariantMetafieldContentChange.bind(this));
      }
    }

    getOptionValues(optionName) {
      if (!this.optionValues[optionName]) {
        function filterUnique(value, index, array) {
          return array.indexOf(value) === index;
        }
        var ix = this.productData.options.indexOf(optionName);
        this.optionValues[optionName] = this.productData.variants.map(v=>v['option'+(1+ix)]).filter(filterUnique);
      }
      return this.optionValues[optionName];
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.originalRequiredOptions.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      //lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });

      if(this.badgePerBottle){
        if(variant.custom.per_bottle_badge){
          this.badgePerBottle.textContent = variant.custom.per_bottle_badge;
        }
        else if(this.productData.per_bottle_product){
          this.badgePerBottle.textContent = this.productData.per_bottle_product;
        }
      }
    }

    onVariantMetafieldContentChange(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || !this.variantContentByVariantId) return;

      var variantId = String(variant.id);
      var content = this.variantContentByVariantId;
      var heroHtml = content.heroDescription ? content.heroDescription[variantId] : '';
      var descriptionHtml = content.descriptionMetaobject ? content.descriptionMetaobject[variantId] : '';
      var importantHtml = content.importantInformation ? content.importantInformation[variantId] : '';

      document.querySelectorAll('[data-variant-hero-description]').forEach((element) => {
        if (heroHtml) {
          element.innerHTML = heroHtml;
          element.style.display = '';
        } else {
          element.innerHTML = '';
          element.style.display = 'none';
        }
      });

      document.querySelectorAll('[data-variant-description-metaobject]').forEach((element) => {
        if (descriptionHtml) {
          element.innerHTML = descriptionHtml;
          element.style.display = '';
        } else {
          element.innerHTML = '';
          element.style.display = 'none';
        }
      });

      document.querySelectorAll('[data-variant-important-information]').forEach((element) => {
        if (importantHtml) {
          element.innerHTML = importantHtml;
          element.style.display = '';
        } else {
          element.innerHTML = '';
          element.style.display = 'none';
        }
      });

      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.checkElems();
      }
    }
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      var defaultIdInput = this.querySelector('add-to-cart-form input[name="id"]') || this.querySelector('input[name="id"]');
      this.defaultVariantId = defaultIdInput ? String(defaultIdInput.value) : null;
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      this._atcOptionsWrapper = this.querySelector('.atc-options-wrapper');
      if (this._atcOptionsWrapper) {
        this._atcOptionsWrapper.addEventListener('click', (evt) => {
          if (!evt.target.closest('.close')) return;
          evt.preventDefault();
          evt.stopPropagation();
          this.closeOptions();
        });
      }

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          self.colorSwatches = self.querySelector('product-swatch.color-swatches');
          if (self.colorSwatches) {
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin',self.colorSwatches);
          }
        }, 10);
      }
    }

    openOptions(e) {
      e.preventDefault();
      var wrapper = this._atcOptionsWrapper || this.querySelector('.atc-options-wrapper');
      if (!wrapper) return;

      var panel = wrapper.querySelector('.form');
      var scrollContainer = wrapper.querySelector('.form-scroll');

      this._atcOptionsWrapper = wrapper;
      wrapper.classList.add('open');
      this.classList.add('expand');

      var gridItem = this.closest('.product-item, .grid-item, .keen-slider-slide');
      if (gridItem) {
        this._atcGridItem = gridItem;
        gridItem.classList.add('atc-panel-open');
      }

      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
        requestAnimationFrame(function() {
          scrollContainer.scrollTop = 0;
        });
      }

      if (panel) {
        $s.trapFocus(panel);
      }

      var self = this;

      if (!this.clickOutHandler) {
        this.clickOutHandler = function(evt) {
          var activeWrapper = self._atcOptionsWrapper || self.querySelector('.atc-options-wrapper');
          if (!activeWrapper || !activeWrapper.classList.contains('open')) return;
          var activePanel = activeWrapper.querySelector('.form');
          if (!activePanel) return;
          if (evt.target.closest('.close')) return;
          if (activePanel !== evt.target && !activePanel.contains(evt.target)) {
            self.closeOptions();
          }
        };
      }
      document.addEventListener('mousedown', this.clickOutHandler);

      setTimeout(function() {
        var productButtons = self.querySelector('product-buttons');
        var variantsElement = self.querySelector('product-variants');
        if (productButtons && productButtons.updateButtonState && variantsElement && variantsElement.getCurrentVariant) {
          var variant = variantsElement.getCurrentVariant();
          if (variant) {
            productButtons.updateButtonState(variant);
          }
        }
      }, 100);
    }
    closeOptions() {
      var wrapper = this._atcOptionsWrapper || this.querySelector('.atc-options-wrapper');
      if (!wrapper || !wrapper.classList.contains('open')) return;

      wrapper.classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();

      if (this._atcGridItem) {
        this._atcGridItem.classList.remove('atc-panel-open');
        this._atcGridItem = null;
      }

      this._atcOptionsWrapper = wrapper;
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var isDefaultVariant = this.defaultVariantId && String(variant.id) === this.defaultVariantId;
      var image = !isDefaultVariant && variant.featured_media && super.isSwatchSelected() ? variant.featured_image : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      //update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.originalRequiredOptions.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        requestAnimationFrame(() => {
          this.updateButtonState(e.detail.variant);
          this.updateCtaMode();
        });
      });

      this.mainElement.addEventListener('change', (e)=>{
        if (e.target && e.target.name === 'purchase_option') {
          var variant = this.mainElement.variantsElement && this.mainElement.variantsElement.getCurrentVariant
            ? this.mainElement.variantsElement.getCurrentVariant()
            : null;
          if (variant) {
            requestAnimationFrame(() => {
              this.updateButtonState(variant);
              this.updateCtaMode();
            });
          } else {
            this.updateCtaMode();
          }
        }
      });

      this.mainElement.addEventListener('sellingPlanChange', () => {
        this.updateCtaMode();
      });
      this.mainElement.addEventListener('quantityChange', () => {
        this.updateCtaMode();
      });
      this.mainElement.addEventListener('pdpQtySelectorsChange', () => {
        this.updateCtaMode();
      });

      requestAnimationFrame(() => {
        this.updateCtaMode();
      });
      [200, 800, 1600].forEach((ms) => {
        window.setTimeout(() => {
          this.updateCtaMode();
        }, ms);
      });
    }

    updateButtonState(variant) {
      try {
        var requiredBtn = this.querySelector('.btn.selection-required');
        var addBtn = this.querySelector('.btn.add');
        var wrapperbundle = this.mainElement.querySelector('.bundle-cart-buttons');
        var oneTimeSelected = ProductButtons.isOneTimePurchaseSelected(this.mainElement);
        var atcRow = this.closest('.qtty-atc');
        var soldOut = !(variant && variant.available);
        if (atcRow && this.mainElement.classList.contains('stay-ai-new-pdp')) {
          atcRow.classList.toggle('is-sold-out', soldOut && !this.required());
        }

        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
          if (addBtn) addBtn.style.display = 'none';
          if (wrapperbundle) wrapperbundle.style.display = 'none';
        } else if (variant && variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          if (addBtn) addBtn.style.display = '';
          if (wrapperbundle) {
            wrapperbundle.style.display = oneTimeSelected ? '' : 'none';
          }
          this.querySelector('.sold-out-message').style.display = 'none';
          if (requiredBtn) requiredBtn.style.display = 'none';
          this.updateCtaMode();
        } else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          if (addBtn) addBtn.style.display = 'none';
          if (wrapperbundle) wrapperbundle.style.display = 'none';
          this.querySelector('.sold-out-message').style.display = '';
          if (requiredBtn) requiredBtn.style.display = 'none';
        }
      } catch (error) {
        console.error('Error updating buttons:', error);
      }
    }

    getAtcSavePercent() {
      var qtyRoot = this.mainElement.querySelector('[data-pdp-qty-selectors]');
      var isOneTime = ProductButtons.isOneTimePurchaseSelected(this.mainElement);
      if (qtyRoot) {
        var active = qtyRoot.querySelector('.pdp-qty-opt.is-active');
        if (active) {
          var attr = isOneTime ? 'data-onetime-disc' : 'data-disc';
          var qtyDisc = parseFloat(active.getAttribute(attr) || '0');
          if (qtyDisc > 0) return Math.round(qtyDisc * 100);
        }
      }
      if (isOneTime) return 0;

      var host = this.mainElement.querySelector('product-selling-plan');
      var planId = host && host.input && String(host.input.value || '').trim();
      if (planId && host.sellingPlanGroups && host.sellingPlanGroups.length) {
        var gi = 0;
        var pi = 0;
        for (gi = 0; gi < host.sellingPlanGroups.length; gi++) {
          var plans = host.sellingPlanGroups[gi] && host.sellingPlanGroups[gi].selling_plans;
          if (!plans) continue;
          for (pi = 0; pi < plans.length; pi++) {
            if (String(plans[pi].id) !== planId) continue;
            var adj = plans[pi].price_adjustments && plans[pi].price_adjustments[0];
            if (adj && adj.value) return Math.round(parseFloat(adj.value));
          }
        }
      }

      var disc = this.mainElement.querySelector('.subscription .option-discount');
      var m = disc && String(disc.textContent || '').match(/(\d+(?:\.\d+)?)\s*%/);
      return m ? Math.round(parseFloat(m[1])) : 0;
    }

    updateCtaMode() {
      var addBtn = this.querySelector('.btn.add');
      if (!addBtn || !addBtn.classList.contains('pdp-atc-cta')) return;
      var isOneTime = ProductButtons.isOneTimePurchaseSelected(this.mainElement);
      addBtn.classList.toggle('pdp-atc-cta--subscribe', !isOneTime);
      var saveEl = addBtn.querySelector('.pdp-atc-cta__save');
      if (!saveEl) return;
      var pct = this.getAtcSavePercent();
      addBtn.classList.toggle('pdp-atc-cta--has-save', pct > 0);
      if (pct) {
        saveEl.textContent = pct + '% off';
        saveEl.hidden = false;
      } else {
        saveEl.textContent = '';
        saveEl.hidden = true;
      }
    }

    static isOneTimePurchaseSelected(mainElement) {
      var sellingPlanEl = mainElement && mainElement.querySelector('product-selling-plan');
      if (!sellingPlanEl) return true;
      var checkedOption = sellingPlanEl.querySelector('[name="purchase_option"]:checked');
      if (!checkedOption) return true;
      if (checkedOption.closest('.one-time')) return true;
      return checkedOption.value === '' || checkedOption.value === 'onetime';
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a';
        this.requiredMessage = 'Select ' + prep + ' ' + label;
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('variant-sku')) {
  class VariantSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('variant-sku', VariantSKU);
}

if(!customElements.get('variant-coa')) {
  // Helper to wait for spreadsheet_utils functions
  const waitForSpreadsheetUtils = () => {
    return new Promise((resolve) => {
      if (typeof loadCsvData !== 'undefined' && typeof displayDialog !== 'undefined' && typeof hideCoaDialog !== 'undefined') {
        resolve();
      } else {
        const checkInterval = setInterval(() => {
          if (typeof loadCsvData !== 'undefined' && typeof displayDialog !== 'undefined' && typeof hideCoaDialog !== 'undefined') {
            clearInterval(checkInterval);
            resolve();
          }
        }, 10);
        // Fallback timeout after 5 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
          resolve();
        }, 5000);
      }
    });
  };

  class VariantCOA extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.button = this.querySelector('button');
      this.coaData = [];
      this.coaIndex = new Map();
      this.initialized = false;

      // Initialize asynchronously after utils are loaded
      waitForSpreadsheetUtils().then(() => {
        this.initialize();
      });
    }

    async initialize() {
      if (this.initialized) return;
      this.initialized = true;

      var spreadsheet = this.getAttribute('data-spreadsheet');
      if(spreadsheet && spreadsheet!="" && typeof loadCsvData === 'function') {
        try {
          const data = await loadCsvData(spreadsheet);
          this.coaData = data;
          this.coaIndex = this.buildCoaIndex(data);
          this.updateCoa(this.mainElement.getCurrentVariant());
        } catch(err) {
          console.error("Failed to load CSV data:", err);
        }
      }
      
      this.mainElement.addEventListener('variantChange', (e)=>{
      	this.updateCoa(e.detail.variant);
      });

      const coaDialog = document.querySelector('#coa-dialog');
      if (coaDialog) {
        const downloadDialogButton = coaDialog.querySelector('[data-role="download"]');
        const closeDialogButton = coaDialog.querySelector('[data-role="close"]');
        
        if (typeof hideCoaDialog === 'function') {
          coaDialog.addEventListener('click', hideCoaDialog({dialog: coaDialog}));
          if (closeDialogButton) {
            closeDialogButton.addEventListener('click', hideCoaDialog({dialog: coaDialog}));
          }
        }
        
        if (this.button) {
          this.button.addEventListener('click', (e)=>{
            e.preventDefault();
            if (typeof displayDialog === 'function') {
              displayDialog({input: this.button, dialog: coaDialog, downloadButton: downloadDialogButton});
            }
          });
        }
      }
    }

    updateCoa(variant) {
      if(variant && variant.sku) {
        const normalizedSku = this.normalizeSku(variant.sku);
        let coaRow = normalizedSku ? this.coaIndex.get(normalizedSku) : null;

        if(!coaRow) {
          coaRow = this.coaData.find(x => x['SKU'] && x['SKU'].includes(variant.sku));
          if (coaRow) {
            this.storeSkuMapping(variant.sku, coaRow);
          }
        }

        if(coaRow) {
          this.style.display = 'block';
          this.button.dataset.url = coaRow['URL'];
        } else {
          this.style.display = 'none';  
        }
      }else{
        this.style.display = 'none';
      }
    }

    normalizeSku(value) {
      return value ? value.trim().toUpperCase() : '';
    }

    extractSkuTokens(rawSku) {
      if (!rawSku || typeof rawSku !== 'string') {
        return [];
      }
      return rawSku
        .split(SKU_SEPARATOR_PATTERN)
        .map((token) => this.normalizeSku(token))
        .filter(Boolean);
    }

    buildCoaIndex(data) {
      if (!Array.isArray(data)) {
        return new Map();
      }

      const index = new Map();
      data.forEach((row) => {
        if (!row || !row['SKU']) {
          return;
        }
        this.extractSkuTokens(row['SKU']).forEach((token) => {
          if (!index.has(token)) {
            index.set(token, row);
          }
        });
      });

      return index;
    }

    storeSkuMapping(rawSku, row) {
      this.extractSkuTokens(rawSku).forEach((token) => {
        if (!this.coaIndex.has(token)) {
          this.coaIndex.set(token, row);
        }
      });
    }
  }
  customElements.define('variant-coa', VariantCOA);
}

if(!customElements.get('variant-details')) {
  class VariantDetails extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.custom && e.detail.variant.custom.details) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.custom.details;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('variant-details', VariantDetails);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector(':scope > div');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      var counterShown = 0;
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        // Check if media has alt text with variant filters (format: "Strength: 1500MG; Flavor: Natural;")
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';').filter(f => f.trim() !== '');
          filter.forEach((f)=>{
            if(show) {
              var parts = f.split(':');
              if(parts.length >= 2) {
                var key = parts[0].trim();
                var values = parts.slice(1).join(':').trim(); // Handle values that might contain colons
                var optionIndex = this.mainElement.productData.options.findIndex(x=>x.toLowerCase()==key.toLowerCase());
                
                if(optionIndex>=0 && values) {
                  var found = false;
                  // Support comma-separated values: "Strength: 1500MG, 2000MG"
                  values.split(',').forEach((value)=>{
                    var trimmedValue = value.trim();
                    // Match exactly or case-insensitive match
                    if(variant.options[optionIndex]==trimmedValue || 
                       variant.options[optionIndex].toLowerCase()==trimmedValue.toLowerCase()) {
                      found = true;
                    }
                  });
                  // All filters must match (AND logic)
                  show = found && show;
                } else if(key && values) {
                  // If option name doesn't match, don't filter this image (show it)
                  // This allows images without variant filters to always show
                }
              }
            }
          });
        }
        // If no variant filters in alt text, show the image by default
        var mediaElement = this.querySelector('[data-media-id="'+media.id+'"]');
        if(mediaElement) {
          if(show) {
            mediaElement.style.display = 'block';
            counterShown++;
          } else {
            mediaElement.style.display = 'none';
          }
        }
      });
      this.setAttribute("media-amount", counterShown);
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll(':scope > div'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: 0rem)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
        //if(!this.slider.options().vertical && this.slider.slides().filter(x=>x.style.display!='none').length < this.slider.options().slidesPerView) {
          //this.slider.refresh({centered: true});
        //}
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 5,
          spacing: 10,
          vertical: false
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 5,
          spacing: 10,
          vertical: false
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: (slider)=>{
            return !slider.options().vertical && slider.slides().filter(x=>x.style.display!='none').length < slider.options().slidesPerView
          },
          slidesPerView: 6,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 5
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      this.listenEvents = ['variantChange', 'sellingPlanChange', 'pdpQtySelectorsChange'];
      if (this.multiplyQuantity)
        this.listenEvents.push('quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var variant = (e.detail && e.detail.variant) || (this.mainElement.getCurrentVariant && this.mainElement.getCurrentVariant());
          if(!variant) {
            this.finalPriceElement.innerHTML = '';
            if (this.comparePriceElement) this.comparePriceElement.innerHTML = '';
            return;
          }
          var quantity = pdpSelectedQuantity(this.mainElement, this.multiplyQuantity);
          var unitPrice = variant.price;
          var unitCompare = variant.compare_at_price;
          var planInput = this.mainElement.querySelector('input[name="selling_plan"]');
          var planId = planInput && String(planInput.value || '').trim();
          var isOneTime = typeof ProductButtons !== 'undefined' && ProductButtons.isOneTimePurchaseSelected
            ? ProductButtons.isOneTimePurchaseSelected(this.mainElement)
            : !planId;
          var finalTotal = unitPrice * quantity;
          var compareTotal = (unitCompare || 0) * quantity;
          if (!isOneTime && planId && variant.selling_plan_allocations) {
            var alloc = variant.selling_plan_allocations.find(function (x) {
              return String(x.selling_plan_id) === planId;
            });
            if (alloc && alloc.price) {
              unitPrice = alloc.price;
              unitCompare = alloc.compare_at_price || variant.price;
              finalTotal = unitPrice * quantity;
              compareTotal = unitCompare * quantity;
            }
          } else if (isOneTime) {
            var oneRate = pdpOnetimeVolumeRate(this.mainElement, quantity);
            finalTotal = pdpOnetimeVolumeTotal(variant.price, quantity, this.mainElement);
            compareTotal = variant.price * quantity;
            if (oneRate > 0) {
              unitCompare = variant.price;
            }
          }
          this.finalPriceElement.innerHTML = $s.formatMoney(finalTotal).replace('.00','');

          if(this.comparePriceElement) {
            if(compareTotal > finalTotal) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = $s.formatMoney(compareTotal).replace('.00','');
            } else {
              this.comparePriceElement.classList.add('hide');
              this.comparePriceElement.innerHTML = '';
            }
          }
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.instanceIndex = Array.from(this.mainElement.querySelectorAll('product-variants')).indexOf(this);
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      // Use requestAnimationFrame to defer DOM updates
      requestAnimationFrame(() => {
        if(variant) {
          this.variantInput.value = variant.id;
        } else {
          this.variantInput.value = '';
        }
        this.previousVariant = variant;
        this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
        this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

        // Optimize swatch image updates
        if (this.swatchImg) {
          this.updateSwatchImages(variant);
        }
      });
    }

    updateSwatchImages(variant) {
      // Use requestIdleCallback for non-critical image updates
      if (window.requestIdleCallback) {
        requestIdleCallback(() => {
          this.performSwatchImageUpdate(variant);
        });
      } else {
        setTimeout(() => this.performSwatchImageUpdate(variant), 0);
      }
    }

    performSwatchImageUpdate(variant) {
      try {
        var options = ['option1', 'option2', 'option3'];
        var imgOption = options.splice(this.swatchImg.dataset.option/1 -1 ,1);
        
        // Batch DOM updates
        const updates = [];
        this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
          var label = radio.parentNode.querySelector('.label-inner');
          
          var matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
          if (!matchingVariant) {
            matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value);
          }
          
          updates.push({
            label: label,
            imageUrl: matchingVariant && matchingVariant.featured_image ? $s.imgUrlFilter(matchingVariant.featured_image.src, '50x') : ''
          });
        });

        // Apply all updates at once
        updates.forEach(update => {
          if (update.label) {
            update.label.style.backgroundImage = update.imageUrl ? `url(${update.imageUrl})` : '';
          }
        });
      } catch (e) {
        console.error('Error updating swatch images:', e);
      }
    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content" style="width: ${infoLink.dataset.width}rem">
                <img src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available,
            price: variant.price,
            badge: variant.custom.badge
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available,
            price: variant.price,
            badge: variant.custom.badge
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available,
            price: variant.price,
            badge: variant.custom.badge
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Flavor"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.totaloptions = this.mainElement.getCurrentVariant().options.length;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
  		var html = `
  			<div class="option-name">
          ${this.label}${this.infoIcon}:
          <span class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
  			<div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      var isColorSwatch = this.colorSwatchesOptions.indexOf(this.label) > -1;
      var isProductCard = this.closest('.product-card') || this.closest('product-card-atc');
      var useCardStyle = isColorSwatch && !isProductCard;
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        if (useCardStyle) {
          html += `
          <div class="swatch swatch-card" data-available="${option.available}">
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
            <label class="animation" for="${id}">
              <div class="animation active-border swatch-card-inner">
                <div class="animation label-inner color-${optionValueHandle} ${optionNameHandle}-${optionValueHandle}"></div>
                <div class="swatch-card-text">
                  <span class="opt-value ease-animation">${option.value}</span>
                  ${option.badge ? '<span class="opt-dosage">' + option.badge + '</span>' : ''}
                </div>
              </div>
            </label>
          </div>
          `;
        } else {
  			html += `
          <div class="swatch" data-available="${option.available}">
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
  				  <label class="animation" for="${id}">
              <div class="animation flex align-items-center active-border">
                <div class="animation label-inner ${isColorSwatch ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
                  `;
                  if(!isColorSwatch){
                    html += `<span class="opt-value ease-animation">${option.value}</span>`;
                    if(this.totaloptions == this.optionNumber) {
                      html += '<span class="opt-price hide">' + $s.formatMoney(option.price).replace('.00', '') + '</span>';
                      if(option.badge) {
                        html += '<span class="opt-badge small-label flex align-items-center"><svg aria-hidden="true" tabindex="-1" class="icon icon-checkmark-simple" viewBox="0 0 32 32"><path d="M27.9,7.4,12.7,22.6,4.1,14"/></svg>' + option.badge + '</span>';
                      }
                    }
                  }
                html += `
                </div>
              `;
              if(isColorSwatch){
                html += `<span class="ease-animation aa">${option.value}</span></div>`;
              }
              else{
                html += '</div>';
              }
              html += `
            </label>
          </div>
  			`;
        }
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name" for="${optionId}">
        ${this.label}${this.infoIcon}: 
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}"></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>- Select -</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? " - Sold Out" : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      window.addEventListener('scroll', this.scrollHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('product-main');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}



//REF: FEATURE SELLING PLANS
if(!customElements.get('product-selling-plan')) {
  class ProductSellingPlan extends HTMLElement {
    constructor() {
      super();      
      this.mainElement = this.closest('.product-main-element');
      this.customerTags = document.querySelector('[type="application/json"][data-customer-json]') ? document.querySelector('[type="application/json"][data-customer-json]').textContent : '';
      this.input = this.querySelector('[name="selling_plan"]');
      this.inputFrequencyName = this.querySelector('[name="selling_plan_frequency"]');
      this.groupsContainer = this.querySelector('[data-groups]');
      this.plansContainer = null; //obtained after every group render
      this.textOnetime = this.dataset.textOnetime || "One-Time Purchase";
      this.textSubscribe = this.dataset.textSubscribe || "Subscribe";
      this.textSubscribeSave = this.dataset.textSubscribeSave || "Subscribe \u0026 Save";
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false
      this.addToCartComparePrice = this.mainElement.querySelector('product-price')?.comparePriceElement;
      this.addToCartFinalPrice = this.mainElement.querySelector('product-price')?.finalPriceElement;
      this.plpAddButtonPrice = this.mainElement.querySelector('.bundle-price-1');
      
      this.input.addEventListener('change', ()=>{
        var currentSellingPlan = this.getCurrentPlan();
        this.sellingPlanChange(currentSellingPlan);
        this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: currentSellingPlan}}));
        this.getUpdateInfo();
      });

      //Filter SPGs that aren't from the current app
      this.sellingPlanGroups = this.mainElement.productData.sellingPlanGroups.filter(g => g.app_id == '5859381');    
      this.veteranCustomer = false;

      //Filter SPG if any of this tags are present for the customer
      const specialTags = "vet,firstresponder,med,Medical,First Responder,Veteran";
      this.customerTags = JSON.parse(this.customerTags);
      
      if (this.customerTags && this.customerTags.length > 0 &&
        specialTags.split(',').some(tag => this.customerTags.includes(tag)))
      {
        this.sellingPlanGroups = this.sellingPlanGroups.filter(g => g.name.includes('Veteran'));
        this.veteranCustomer = true;
      }else{
        this.sellingPlanGroups = this.sellingPlanGroups.filter(g => !g.name.includes('Veteran'));
        this.veteranCustomer = false;
      }
      this.prepaidGroup = this.sellingPlanGroups.find(g => g.name.includes('Prepaid'));
      this.standardGroup = this.sellingPlanGroups.find(g => !g.name.includes('Prepaid'));
     
      if(this.prepaidGroup){
        this.prepaidDiscount = (this.prepaidGroup.selling_plans[0].price_adjustments?.length > 0 ? this.prepaidGroup.selling_plans[0].price_adjustments[0].value : 0); // expected percentage
      }

      this.listenEvents = ['variantChange'];
      if (this.multiplyQuantity)
        this.listenEvents.push('quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          if (event === 'quantityChange') {
            this.syncSubscriptionDisplay();
            this.syncAddButtonPriceFromSelection();
            return;
          }
          // Save the current selection BEFORE regenerating HTML
          var previousSelection = '';
          var previousChecked = this.groupsContainer ? this.groupsContainer.querySelector('[name="purchase_option"]:checked') : null;
          if (previousChecked) {
            previousSelection = previousChecked.value; // '' for one-time, group ID for subscription
          }
          
          var parkedQty = this.querySelector('[data-pdp-qty-selectors]');
          if (parkedQty && this.groupsContainer.contains(parkedQty)) {
            this.appendChild(parkedQty);
          }
          this.groupsContainer.innerHTML = this.getGroupsHtml();
          this.plansContainer = this.querySelector('[data-plans]');  //obtained newly generated element
          
          let shipments = 1;
          let currentVariant = this.mainElement.getCurrentVariant();
          let price = currentVariant.price; // Default to variant price
          if (currentVariant && currentVariant.selling_plan_allocations && this.standardGroup) {
            var allocation = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_group_id==this.standardGroup.id);
            if (allocation && allocation.price) {
              price = allocation.price;
            }
          }
          let finalPrice = $s.formatMoney(price).replace('.00', '');
          let comparePrice = $s.formatMoney(currentVariant.price).replace('.00', '');
          
          //Prepaid Subscription 
          this.prepaidSubscription = this.groupsContainer.querySelector("input[name='prepaid_purchase_option']");
          if(this.prepaidSubscription){
           
            this.prepaidSubscription.addEventListener('change', ()=>{
              currentVariant = this.mainElement.getCurrentVariant();              
              var prepaidSelect = this.groupsContainer.querySelector('select.prepaidPlans');
              
              if(this.prepaidSubscription.checked){
                //Select subscription option and hide the standard subscription info
                this.groupsContainer.querySelector('.subscription input[name="purchase_option"]').click();
                this.prepaidSubscription.checked = true;
                var standardSubscriptionDiv = this.groupsContainer.querySelector('.subscription div.standardSubscription');
                if (standardSubscriptionDiv) {
                  standardSubscriptionDiv.style.display = 'none';
                }
                
                //Update selling plan group input value to be prepaid
                this.querySelector('[name="prepaid_purchase_option"]:checked').value = this.prepaidGroup.id;

                //Update price and discount
                shipments = 3;
                price = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_group_id==this.prepaidGroup.id).price;
                comparePrice = $s.formatMoney(currentVariant.price * shipments).replace('.00', '');
                finalPrice = $s.formatMoney(price).replace('.00', '');
                var comparePriceEl = this.groupsContainer.querySelector('.subscription .option-price .compare');
                var finalPriceEl = this.groupsContainer.querySelector('.subscription .option-price .final');
                var discountEl = this.groupsContainer.querySelector('.subscription .option-label .option-discount');
                if (comparePriceEl) comparePriceEl.innerHTML = comparePrice;
                if (finalPriceEl) finalPriceEl.innerHTML = finalPrice;
                if (discountEl && this.prepaidGroup && this.prepaidGroup.selling_plans && this.prepaidGroup.selling_plans[0] && this.prepaidGroup.selling_plans[0].price_adjustments && this.prepaidGroup.selling_plans[0].price_adjustments[0]) {
                  discountEl.textContent = this.formatSaveBadge(this.prepaidGroup.selling_plans[0].price_adjustments[0].value);
                }
                if (this.addToCartComparePrice) this.addToCartComparePrice.innerHTML = comparePrice;
                this.setAddButtonPrice(finalPrice);
                
                //Update selling plan input value
                prepaidSelect.removeAttribute('disabled');
                prepaidSelect.addEventListener('change', (e)=>{
                  this.updateSellingPlan(e.target.value);
                  shipments = parseInt(prepaidSelect.selectedOptions[0].innerText.match(/\d+/g)[0]); 
                  var planAllocation = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id == e.target.value);
                  price = planAllocation && planAllocation.price ? planAllocation.price : currentVariant.price;
                  comparePrice = $s.formatMoney(currentVariant.price * shipments).replace('.00', '');
                  finalPrice = $s.formatMoney(price).replace('.00', '');
                  if (this.groupsContainer) {
                    var comparePriceEl = this.groupsContainer.querySelector('.subscription .option-price .compare');
                    var finalPriceEl = this.groupsContainer.querySelector('.subscription .option-price .final');
                    if (comparePriceEl) comparePriceEl.innerHTML = comparePrice;
                    if (finalPriceEl) finalPriceEl.innerHTML = finalPrice;
                  }
                  if (this.addToCartComparePrice) this.addToCartComparePrice.innerHTML = comparePrice;
                  this.setAddButtonPrice(finalPrice);
                });
                if (prepaidSelect) {
                  this.input.value = prepaidSelect.value;
                }
                
              }else{
                //Update selling plan group input value to be the standard group
                var checkedInput = this.querySelector('[name="purchase_option"]:checked');
                if (checkedInput && this.standardGroup) {
                  checkedInput.value = this.standardGroup.id;
                }
                if (this.plansContainer) {
                  var enabledSelect = this.plansContainer.querySelector('select.enabled');
                  if (enabledSelect) {
                    this.input.value = enabledSelect.value;
                  }
                }
                var allocation = currentVariant.selling_plan_allocations ? currentVariant.selling_plan_allocations.find(x=>x.selling_plan_group_id==this.standardGroup?.id) : null;
                price = allocation && allocation.price ? allocation.price : currentVariant.price;
                comparePrice = $s.formatMoney(currentVariant.price).replace('.00', '');
                finalPrice = $s.formatMoney(price).replace('.00', '');
                
                if (this.groupsContainer) {
                  var standardSubscriptionDiv = this.groupsContainer.querySelector('.subscription div.standardSubscription');
                  if (standardSubscriptionDiv) {
                    standardSubscriptionDiv.style.display = 'block';
                  }
                  var comparePriceEl = this.groupsContainer ? this.groupsContainer.querySelector('.subscription .option-price .compare') : null;
                  var finalPriceEl = this.groupsContainer ? this.groupsContainer.querySelector('.subscription .option-price .final') : null;
                  var discountEl = this.groupsContainer ? this.groupsContainer.querySelector('.subscription .option-label .option-discount') : null;
                  if (comparePriceEl) comparePriceEl.innerHTML = comparePrice;
                  if (finalPriceEl) finalPriceEl.innerHTML = finalPrice;
                  if (discountEl && this.standardGroup && this.standardGroup.selling_plans && this.standardGroup.selling_plans[0] && this.standardGroup.selling_plans[0].price_adjustments && this.standardGroup.selling_plans[0].price_adjustments[0]) {
                    discountEl.textContent = this.formatSaveBadge(this.standardGroup.selling_plans[0].price_adjustments[0].value);
                  }
                }
                if (this.addToCartComparePrice) this.addToCartComparePrice.innerHTML = comparePrice;
                this.setAddButtonPrice(finalPrice);
                if (prepaidSelect && prepaidSelect.options && prepaidSelect.options[0]) {
                  prepaidSelect.options[0].selected = true;
                  prepaidSelect.setAttribute('disabled', 'true');
                }
              }
                
            });

          }

          //Standard Subscription
          if (this.groupsContainer) {
            this.groupsContainer.querySelectorAll('[name="purchase_option"]').forEach((groupInput)=>{
              groupInput.addEventListener('change', ()=>{

                // Update checked="checked" attribute on all purchase options
                this.groupsContainer.querySelectorAll('[name="purchase_option"]').forEach((input)=>{
                  if (input.checked) {
                    input.setAttribute('checked', 'checked');
                  } else {
                    input.removeAttribute('checked');
                  }
                });

                // If one-time purchase is selected (empty value), clear the selling plan immediately
                if (groupInput.closest('.one-time') || groupInput.value === '' || groupInput.value === 'onetime') {
                  this.updateSellingPlan('');
                }

                //Clear prepaid checkbox
                this.prepaidSubscription ? this.prepaidSubscription.checked = false : '';
                var isOneTime = groupInput.closest('.one-time') || groupInput.value === '' || groupInput.value === 'onetime';
                var standardSubscriptionDiv = this.groupsContainer ? this.groupsContainer.querySelector('.subscription div.standardSubscription') : null;
                var prepaidWrap = this.groupsContainer ? this.groupsContainer.querySelector('.subscription .prepaidSubscription') : null;
                if (standardSubscriptionDiv) {
                  // Keep benefits list available; frequency/prepaid visibility is handled in CSS
                  // when Subscribe is not selected. Restore block after prepaid mode hid it.
                  standardSubscriptionDiv.style.display = 'block';
                }
                if (prepaidWrap) {
                  prepaidWrap.style.display = isOneTime ? 'none' : '';
                }

                var plan = this.plansContainer ? this.plansContainer.querySelector('select') : null;
              let currentVariant = this.mainElement.getCurrentVariant();
              
              // Determine which plan name to preserve - use current input value (plan ID) to find the plan name
              var selectedPlanName = '';
              var selectedPlanId = this.input.value; // Preserve the current plan ID
              
              if (selectedPlanId && selectedPlanId != '') {
                // Find the plan by ID to get its name - this preserves user's manual selection
                this.sellingPlanGroups.forEach((group) => {
                  group.selling_plans.forEach((planItem) => {
                    if (planItem.id == selectedPlanId) {
                      selectedPlanName = planItem.name.trim();
                    }
                  });
                });
              } else if (plan && plan.selectedIndex >= 0 && plan.value) {
                // Fallback to currently selected plan ID if available
                selectedPlanId = plan.value;
                selectedPlanName = plan.options[plan.selectedIndex].text;
              }

              //get html with same plan name currently selected, or default to 30-day plan only if nothing is selected
              if (this.plansContainer) {
                this.plansContainer.innerHTML = this.getPlansHtml(selectedPlanName, selectedPlanId);
              }
                            
              //only get the select if enabled, otherwise clear selling_plan input value
              var select = this.plansContainer ? this.plansContainer.querySelector('select.enabled') : null;

              if(select) {
                select.addEventListener('change', (e)=>{
                  this.updateSellingPlan(e.target.value);
                  this.syncSubscriptionDisplay();
                });
                
                // Set the select value based on current input value, or default to 30-day plan
                var planToSelect = this.input.value;
                if (!planToSelect || planToSelect == '') {
                  // Find 30-day plan ID only if no plan is currently selected
                  this.sellingPlanGroups.forEach((group) => {
                    group.selling_plans.forEach((planItem) => {
                      var planName = planItem.name.toLowerCase();
                      var planOption = planItem.options[0]?.value?.toLowerCase() || '';
                      if ((planName.includes('30') || planOption.includes('30') || planName.includes('thirty') || planOption.includes('thirty')) &&
                          !planName.includes('60') && !planName.includes('90') && !planName.includes('120') &&
                          !planOption.includes('60') && !planOption.includes('90') && !planOption.includes('120')) {
                        if (currentVariant.selling_plan_allocations) {
                          var allocation = currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == planItem.id);
                          if (allocation) {
                            planToSelect = planItem.id;
                          }
                        }
                      }
                    });
                  });
                }
                
                // Only set the value if we have a valid plan ID and it exists in the select
                if(planToSelect && select.querySelector('option[value="'+planToSelect+'"]')) {
                  select.value = planToSelect;
                  this.updateSellingPlan(planToSelect);
                } else if (!planToSelect) {
                  // If no plan selected and no 30-day found, select the first available plan
                  var firstOption = select.querySelector('option[value]');
                  if (firstOption) {
                    planToSelect = firstOption.value;
                    select.value = planToSelect;
                    this.updateSellingPlan(planToSelect);
                  }
                }
                // Only dispatch change if we actually set a value
                if (planToSelect) {
                  select.dispatchEvent(new Event('change', {bubbles: true}));
                }
              } else {
                // No select.enabled found
                if (groupInput.value === '' || groupInput.value === 'onetime') {
                  // One-time purchase selected - clear selling plan
                  this.updateSellingPlan("");
                } else {
                  // Subscription selected but no select found - find a valid plan
                  var foundPlan = null;
                  // Try to find 30-day plan first
                  this.sellingPlanGroups.forEach((group) => {
                    group.selling_plans.forEach((planItem) => {
                      var planName = (planItem.name || '').toLowerCase();
                      var planOption = planItem.options && planItem.options[0] ? (planItem.options[0].value || '').toLowerCase() : '';
                      if ((planName.includes('30') || planOption.includes('30')) && !foundPlan) {
                        if (currentVariant.selling_plan_allocations) {
                          var alloc = currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == planItem.id);
                          if (alloc) {
                            foundPlan = planItem.id;
                          }
                        }
                      }
                    });
                  });
                  // Fallback to first available plan
                  if (!foundPlan) {
                    this.sellingPlanGroups.forEach((group) => {
                      group.selling_plans.forEach((planItem) => {
                        if (!foundPlan && currentVariant.selling_plan_allocations) {
                          var alloc = currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == planItem.id);
                          if (alloc) {
                            foundPlan = planItem.id;
                          }
                        }
                      });
                    });
                  }
                  if (foundPlan) {
                    this.updateSellingPlan(foundPlan);
                  }
                }
                this.syncSubscriptionDisplay();
                this.syncAddButtonPriceFromSelection();

              }
            });
          });
          }

          // Restore the previously selected option (saved before HTML regeneration)
          var groupInput = null;
          if (this.groupsContainer) {
            // First try to restore the previous selection
            if (previousSelection !== undefined && previousSelection !== null) {
              groupInput = this.groupsContainer.querySelector('[name="purchase_option"][value="'+previousSelection+'"]');
            }
            // If no previous selection or element not found, use currentPlan or default to one-time
            if (!groupInput) {
              var currentPlan = this.getCurrentPlan();
              if(currentPlan) {
                groupInput = this.groupsContainer.querySelector('[name="purchase_option"][value="'+currentPlan.selling_plan_group_id+'"]');
              } else {
                groupInput = this.groupsContainer.querySelector('[name="purchase_option"][value=""]');
              }
            }
            if (groupInput) {
              groupInput.checked = true;
              groupInput.setAttribute('checked', 'checked');
              // Sync checked attribute on all purchase options
              this.groupsContainer.querySelectorAll('[name="purchase_option"]').forEach((input)=>{
                if (input.checked) {
                  input.setAttribute('checked', 'checked');
                } else {
                  input.removeAttribute('checked');
                }
              });

              // getGroupsHtml() leaves [data-plans] empty and defaults One-Time to checked.
              // Fire change so the listener rebuilds frequency options and keeps Subscribe selected.
              groupInput.dispatchEvent(new Event('change', { bubbles: true }));
              
              // Ensure selling_plan is correctly set based on restored selection
              if (groupInput.value === '' || groupInput.value === 'onetime') {
                // One-time purchase - clear selling plan
                this.updateSellingPlan('');
              } else {
                // Subscription restored - ensure selling_plan has a value
                // Check if there's a select with the current plan
                var select = this.plansContainer ? this.plansContainer.querySelector('select.enabled') : null;
                if (select && select.value) {
                  this.updateSellingPlan(select.value);
                } else if (!this.input.value) {
                  // No plan set - find default (30-day or first available)
                  // currentVariant already declared earlier in this scope
                  var foundPlan = null;
                  this.sellingPlanGroups.forEach((group) => {
                    group.selling_plans.forEach((planItem) => {
                      var planName = (planItem.name || '').toLowerCase();
                      if ((planName.includes('30') && !planName.includes('60') && !planName.includes('90')) && !foundPlan) {
                        if (currentVariant && currentVariant.selling_plan_allocations) {
                          var alloc = currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == planItem.id);
                          if (alloc) foundPlan = planItem.id;
                        }
                      }
                    });
                  });
                  if (!foundPlan) {
                    this.sellingPlanGroups.forEach((group) => {
                      group.selling_plans.forEach((planItem) => {
                        if (!foundPlan && currentVariant && currentVariant.selling_plan_allocations) {
                          var alloc = currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == planItem.id);
                          if (alloc) foundPlan = planItem.id;
                        }
                      });
                    });
                  }
                  if (foundPlan) this.updateSellingPlan(foundPlan);
                }
              }
            }
          }
          this.syncAddButtonPriceFromSelection();
          this.syncSubscriptionDisplay();
        });
      });

      this.syncAddButtonPriceFromSelection();
      this.syncSubscriptionDisplay();
    }

    setAddButtonPrice(formattedPrice) {
      var finalEl =
        this.mainElement.querySelector('.qtty-atc product-price .final') ||
        this.addToCartFinalPrice;
      if (finalEl) {
        finalEl.innerHTML = formattedPrice;
      }
      if (this.plpAddButtonPrice) {
        this.plpAddButtonPrice.textContent = formattedPrice;
      }
    }

    syncAddButtonPriceFromSelection() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if (!currentVariant) return;
      var quantity = this.getSubscribeQuantity();

      var checked = this.groupsContainer ? this.groupsContainer.querySelector('[name="purchase_option"]:checked') : null;
      var isOneTime = !checked || checked.closest('.one-time') || checked.value === '' || checked.value === 'onetime';

      var compareEl =
        this.mainElement.querySelector('.qtty-atc product-price .compare') ||
        this.addToCartComparePrice;

      if (isOneTime) {
        var oneRate = pdpOnetimeVolumeRate(this.mainElement, quantity);
        var oneTotal = pdpOnetimeVolumeTotal(currentVariant.price, quantity, this.mainElement);
        var oneCompare = currentVariant.price * quantity;
        if (compareEl) {
          if (oneRate > 0 || (currentVariant.compare_at_price > currentVariant.price)) {
            var compareAmt = oneRate > 0 ? oneCompare : currentVariant.compare_at_price * quantity;
            if (compareAmt > oneTotal) {
              compareEl.innerHTML = $s.formatMoney(compareAmt).replace('.00', '');
              compareEl.classList.remove('hide');
            } else {
              compareEl.innerHTML = '';
              compareEl.classList.add('hide');
            }
          } else {
            compareEl.innerHTML = '';
            compareEl.classList.add('hide');
          }
        }
        this.setAddButtonPrice($s.formatMoney(oneTotal).replace('.00', ''));
        return;
      }

      var unitPrice = currentVariant.price;
      var unitCompare = currentVariant.price;

      if (this.input && this.input.value && currentVariant.selling_plan_allocations) {
        var planAllocation = currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == this.input.value);
        if (planAllocation && planAllocation.price) {
          unitPrice = planAllocation.price;
          unitCompare = planAllocation.compare_at_price || currentVariant.price;
        }
      } else if (this.standardGroup && currentVariant.selling_plan_allocations) {
        var groupAllocation = currentVariant.selling_plan_allocations.find(x => x.selling_plan_group_id == this.standardGroup.id);
        if (groupAllocation && groupAllocation.price) {
          unitPrice = groupAllocation.price;
          unitCompare = groupAllocation.compare_at_price || currentVariant.price;
        }
      }

      if (compareEl) {
        if (unitCompare > unitPrice) {
          compareEl.innerHTML = $s.formatMoney(unitCompare * quantity).replace('.00', '');
          compareEl.classList.remove('hide');
        } else {
          compareEl.innerHTML = '';
          compareEl.classList.add('hide');
        }
      }
      this.setAddButtonPrice($s.formatMoney(unitPrice * quantity).replace('.00', ''));
    }

    updateSellingPlan(sellingPlanId) {
      this.input.value = sellingPlanId;
      if (this.inputFrequencyName) {
        if (sellingPlanId) {
          var plan = null;
          var gi = 0;
          for (gi = 0; gi < this.sellingPlanGroups.length; gi++) {
            var group = this.sellingPlanGroups[gi];
            if (!group.selling_plans) continue;
            plan = group.selling_plans.find(function (x) {
              return String(x.id) === String(sellingPlanId);
            });
            if (plan) break;
          }
          if (plan && plan.options && plan.options[0]) {
            this.inputFrequencyName.value = plan.options[0].value;
          }
        } else {
          this.inputFrequencyName.value = '';
        }
      }
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
      this.syncAddButtonPriceFromSelection();
      this.syncSubscriptionDisplay();
    }

    getSubscribeQuantity() {
      var qtyRoot = this.mainElement && this.mainElement.querySelector('[data-pdp-qty-selectors]');
      if (qtyRoot) {
        var active = qtyRoot.querySelector('.pdp-qty-opt.is-active');
        var n = active ? parseInt(active.getAttribute('data-qty'), 10) : 0;
        if (n > 0) return n;
      }
      return this.multiplyQuantity ? (parseInt(this.mainElement.getQuantity(), 10) || 1) : 1;
    }

    getMaxSubscribeDiscount() {
      var max = 0;
      var qtyRoot = this.mainElement && this.mainElement.querySelector('[data-pdp-qty-selectors]');
      if (qtyRoot) {
        qtyRoot.querySelectorAll('.pdp-qty-opt[data-disc]').forEach((btn) => {
          var pct = Math.round((parseFloat(btn.getAttribute('data-disc') || '0') || 0) * 100);
          if (pct > max) max = pct;
        });
      }
      (this.sellingPlanGroups || []).forEach((group) => {
        if ((group.name || '').includes('Prepaid')) return;
        var nameMatch = String(group.name || '').match(/(\d+(?:\.\d+)?)\s*%/);
        if (nameMatch) max = Math.max(max, Math.round(parseFloat(nameMatch[1])));
        (group.selling_plans || []).forEach((plan) => {
          var adj = plan.price_adjustments && plan.price_adjustments[0];
          if (adj && adj.value) max = Math.max(max, Math.round(parseFloat(adj.value)));
        });
      });
      return max;
    }

    getSelectedSubscribeDiscount() {
      var qtyRoot = this.mainElement && this.mainElement.querySelector('[data-pdp-qty-selectors]');
      if (qtyRoot) {
        var active = qtyRoot.querySelector('.pdp-qty-opt.is-active');
        if (active) {
          var pct = Math.round((parseFloat(active.getAttribute('data-disc') || '0') || 0) * 100);
          if (pct > 0) return pct;
        }
      }
      var planId = this.input && this.input.value;
      var gi = 0;
      var pi = 0;
      for (gi = 0; gi < (this.sellingPlanGroups || []).length; gi++) {
        var group = this.sellingPlanGroups[gi];
        var plans = group && group.selling_plans;
        if (!plans) continue;
        for (pi = 0; pi < plans.length; pi++) {
          if (String(plans[pi].id) !== String(planId)) continue;
          var adj = plans[pi].price_adjustments && plans[pi].price_adjustments[0];
          if (adj && adj.value) return Math.round(parseFloat(adj.value));
        }
      }
      return 0;
    }

    syncSubscriptionDisplay() {
      var currentVariant = this.mainElement && this.mainElement.getCurrentVariant && this.mainElement.getCurrentVariant();
      if (!currentVariant) return;
      var quantity = this.getSubscribeQuantity();
      var planId = this.input && String(this.input.value || '').trim();
      var unitPrice = currentVariant.price;
      var unitCompare = currentVariant.price;
      if (planId && currentVariant.selling_plan_allocations) {
        var alloc = currentVariant.selling_plan_allocations.find((x) => String(x.selling_plan_id) === String(planId));
        if (alloc && alloc.price) {
          unitPrice = alloc.price;
          unitCompare = alloc.compare_at_price || currentVariant.price;
        }
      }
      var compareEl = this.querySelector('.subscription .option-price .compare');
      var finalEl = this.querySelector('.subscription .option-price .final');
      var badge = this.querySelector('.subscription .option-discount');
      if (compareEl) compareEl.innerHTML = $s.formatMoney(unitCompare * quantity).replace('.00', '');
      if (finalEl) finalEl.innerHTML = $s.formatMoney(unitPrice * quantity).replace('.00', '');
      var discount = this.getSelectedSubscribeDiscount();
      if (badge && discount) badge.textContent = this.formatSaveBadge(discount);
      var banner = this.querySelector('.stay-promo-banner');
      if (banner) {
        var base = (this.getAttribute('data-stay-promo-banner') || '').trim();
        var max = this.getMaxSubscribeDiscount();
        if (base) banner.textContent = max ? (base + '  -  Save up to ' + max + '% off') : base;
      }
      this.getUpdateInfo();
    }

    isNewStayUi() {
      return (
        this.getAttribute('data-stay-freq-cards') === 'true' ||
        this.getAttribute('data-stay-freq-native') === 'true'
      );
    }

    formatSaveBadge(discount) {
      var n = parseFloat(discount);
      if (!n) return '';
      return this.isNewStayUi() ? ('Save ' + n + '%') : (' ' + n + '%');
    }

    getGroupsHtml() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var oneTimeHtml = '';
      var subscriptionHtml = '';
      var quantity = this.getSubscribeQuantity();
      var isPlpQuickPanel = !!this.closest('product-card-atc');
      var plpThumbOnetime = '<span class="pps-thumb pps-thumb-onetime" aria-hidden="true"></span>';
      var plpThumbSubscribe = '<span class="pps-thumb pps-thumb-subscribe" aria-hidden="true"></span>';

      if(!this.mainElement.productData.requiresSellingPlan) {
        let optionId = `plan-option-onetime-${this.mainElement.sectionId}-${$s.randomstring(5)}`;
        let optionCompareAtPrice = '';
        if(currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price){
          optionCompareAtPrice = $s.formatMoney(currentVariant.compare_at_price * quantity).replace('.00', '');
        }
        let optionPrice = $s.formatMoney(currentVariant.price * quantity).replace('.00', '');
        oneTimeHtml += `
          <div class="one-time">
            <input class="checkbox-custom main-input" type="radio" name="purchase_option" value="" id="${optionId}" checked="checked">
            <label class="checkbox-custom-label main-label animation" for="${optionId}">
              <div class="cont one-whole">
                <div class="flex flex-wrap align-items-start pps-purchase-row">
                  ${isPlpQuickPanel ? `
                  ${plpThumbOnetime}
                  <div class="pps-purchase-copy">
                    <div class="option-label"><span class="p4 pps-title">${this.textOnetime}</span></div>
                    <p class="pps-tagline">Pay full price, once</p>
                  </div>` : `
                  <div class="option-label"><span class="p4">${this.textOnetime}</span></div>
                  <div class="option-price-wrap flex flex-wrap ">
                    <div class="option-price"><span class="compare">${optionCompareAtPrice}</span><span class="final">${optionPrice}</span></div>
                  </div>`}
                </div>
              </div>
            </label>
          </div>
        `;
      }
      if(currentVariant) {
        this.sellingPlanGroups.forEach((group)=>{
          let priceAdjustment = group.selling_plans[0].price_adjustments;
          let discount = (priceAdjustment && priceAdjustment.length > 0 ? priceAdjustment[0].value : 0); // expected percentage
          let planAlloc = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_group_id==group.id);
          let inProductCard = this.mainElement.querySelector('.atc-quick-add') == null;
          if(planAlloc) {
            let optionId = `plan-option-${group.id}-${this.mainElement.sectionId}-${$s.randomstring(5)}`;
            let optionPrice = $s.formatMoney(planAlloc.price * quantity).replace('.00', '');
            let variantPrice = $s.formatMoney(currentVariant.price * quantity).replace('.00', '');
            if(!group.name.includes('Prepaid')){
              if (this.isNewStayUi() && subscriptionHtml) {
                return;
              }
              var subscribeTitle = discount ? this.textSubscribeSave : this.textSubscribe;
              var saveBadge = this.formatSaveBadge(discount);
              var useNewStayUi = this.isNewStayUi();
              var promoBase = (this.getAttribute('data-stay-promo-banner') || '').trim();
              var promoMax = this.getMaxSubscribeDiscount() || discount;
              var promoBanner = (!isPlpQuickPanel && useNewStayUi && promoBase)
                ? `<div class="stay-promo-banner">${promoBase}${promoMax ? '  -  Save up to ' + promoMax + '% off' : ''}</div>`
                : '';
              var subscribeHead = isPlpQuickPanel ? `
                      <div class="flex flex-wrap align-items-start pps-purchase-row">
                        ${plpThumbSubscribe}
                        <div class="pps-purchase-copy">
                          <div class="pps-title-row flex flex-wrap align-items-center">
                            <span class="pps-title p4">${subscribeTitle}</span>
                            ${discount ? '<span class="pps-best-value">Best Value</span>' : ''}
                          </div>
                          <p class="pps-tagline">Save more. Delivered on your schedule.</p>
                        </div>
                      </div>` : (useNewStayUi ? `
                      <div class="flex align-items-center pps-purchase-row">
                        <div class="option-label-wrap flex align-items-center">
                          <div class="option-label">
                            <span class="pps-title">` + subscribeTitle + `</span>
                            ` + (saveBadge ? '<span class="option-discount">' + saveBadge + '</span>' : '') + `
                          </div><div class="subscription-info">
                              <div class="badge">?</div>
                              <div class="tooltip animation">Subscribe to this product and have it conveniently delivered to you at the frequency you choose! Promotion subject to change.</div>
                            </div></div>
                        <div class="option-price-wrap">
                          <div class="option-price">` + (discount ? '<span class="compare"> ' + variantPrice + '</span>' : '') + `<span class="final">${optionPrice}</span></div>
                        </div>
                      </div>` : `
                      <div class="flex flex-wrap align-items-center pps-purchase-row">
                        <div class="option-label-wrap flex flex-wrap">
                          <div class="option-label"><span class="small-label p3">` + (discount ? this.textSubscribeSave + '<span class="option-discount"> ' + discount + '%</span>' : this.textSubscribe) + `</span></div><div class="subscription-info">
                              <div class="badge">?</div>
                              <div class="tooltip animation">Subscribe to this product and have it conveniently delivered to you at the frequency you choose! Promotion subject to change.</div>
                            </div></div>
                        <div class="option-price-wrap flex flex-wrap">
                          <div class="option-price">` + (discount ? '<span class="compare"> ' + variantPrice + '</span>' : '') + `<span class="final">${optionPrice}</span></div>
                        </div>
                      </div>`);
              var prepaidBlock = '';
              if (this.prepaidGroup && (inProductCard || isPlpQuickPanel)) {
                if (isPlpQuickPanel) {
                  prepaidBlock = `
                        <div class="prepaidSubscription pps-prepaid-card" for="prepaid-plan-option-${this.prepaidGroup.id}-${this.mainElement.sectionId}">
                          <div class="pps-prepaid-inner flex align-items-start">
                            <input type="checkbox" name="prepaid_purchase_option" value="${this.prepaidGroup.id}" id="prepaid-plan-option-${this.prepaidGroup.id}-${this.mainElement.sectionId}">
                            <div class="pps-prepaid-body">
                              <span class="pps-prepaid-label">PREPAID FOR</span>
                              <div class="field pps-prepaid-field">
                                <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg>
                                <select id="prepaid-frequency-${this.mainElement.sectionId}" disabled class="prepaidPlans pps-prepaid-select">
                                  ${this.prepaidGroup.selling_plans.map(sellingPlan => `<option value="${sellingPlan.id}">${sellingPlan.options[0].value}</option>`).join('')}
                                </select>
                              </div>
                              <div class="pps-prepaid-save">
                                <span class="pps-discount-seal" aria-hidden="true"></span>
                                <span class="pps-prepaid-save-text">and save <strong>${this.prepaidDiscount}%</strong></span>
                              </div>
                            </div>
                          </div>
                        </div>`;
                } else {
                  prepaidBlock = `
                        <div class="prepaidSubscription flex align-items-center" for="prepaid-plan-option-${this.prepaidGroup.id}-${this.mainElement.sectionId}">
                          <input type="checkbox" name="prepaid_purchase_option" value="${this.prepaidGroup.id}" id="prepaid-plan-option-${this.prepaidGroup.id}-${this.mainElement.sectionId}">
                          <span class="subtitle p5 flex flex-wrap">Prepaid for
                          <div class="field">
                            <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg>
                            <select id="prepaid-frequency-${this.mainElement.sectionId}" disabled class="prepaidPlans">
                              ${this.prepaidGroup.selling_plans.map(sellingPlan => `<option value="${sellingPlan.id}">${sellingPlan.options[0].value}</option>`).join('')}
                            </select>
                          </div>
                          and save ${this.prepaidDiscount}%</span>
                        </div>`;
                }
              }
               subscriptionHtml += `
                <div class="subscription">
                  <input class="checkbox-custom main-input" type="radio" name="purchase_option" value="${group.id}" id="${optionId}">
                  <label class="checkbox-custom-label main-label animation" for="${optionId}">
                    ${promoBanner}
                    <div class="cont">
                      ${subscribeHead}
                      <div class="standardSubscription"><div class="custom-info p5"><ul><li><span class="option-discount-info">25%</span> off on all orders</li><li>FREE priority shipping</li><li>Reschedule, hold, or cancel at any time</li><li>60-day money-back guarantee</li></ul></div><div data-plans></div>
                      </div>
                      ${prepaidBlock}
                    </div>
                  </label>
                </div>
              `;
            }
          }
        });
      }
      // New Stay AI PDPs: Subscribe first. Live/normal templates: One-Time first.
      return this.isNewStayUi() ? (subscriptionHtml + oneTimeHtml) : (oneTimeHtml + subscriptionHtml);
    }

    sellingPlanChange(sellingPlan) {
      if (!sellingPlan) return;
      var group = this.getCurrentGroup();
      if (!group || !group.selling_plans) return;
      var plan = group.selling_plans.find((x) => String(x.id) === String(sellingPlan.selling_plan_id || sellingPlan.id));
      if (!plan || !plan.name) return;
      var sellingPlanDescription = plan.name.trim().split('. ');
      sellingPlanDescription.shift();
      sellingPlanDescription = sellingPlanDescription.join('. ');
      var descEl = this.mainElement.querySelector('.option-description-text');
      if (descEl) descEl.innerHTML = sellingPlanDescription;
    }

    getPlansHtml(selectedName, selectedPlanId) {
        selectedPlanId = selectedPlanId || '';
        var currentVariant = this.mainElement.getCurrentVariant();
        var enabled = true;
        var currentGroups = this.getCurrentGroup();
        if (this.isNewStayUi()) {
          currentGroups = this.sellingPlanGroups.filter(function (g) {
            return !(g.name || '').includes('Prepaid');
          });
        } else if(!currentGroups ){
          currentGroups = this.mainElement.productData.sellingPlanGroups.filter(g => g.app_id == '5859381' && !g.name.includes('Prepaid'));          
          enabled = false;
        }
        var inProductCard = this.mainElement.querySelector('.atc-quick-add') != null;
       
        if(inProductCard){
          currentGroups = this.mainElement.productData.sellingPlanGroups.filter(g => g.app_id == '5859381');
        }
        currentGroups = Array.isArray(currentGroups) ? currentGroups : [currentGroups];
        currentGroups = this.veteranCustomer ? currentGroups.filter(g => g.name.includes('Veteran')) : currentGroups.filter(g => !g.name.includes('Veteran'));
      

        var html = '';
        var isPlpPlans = !!this.closest('product-card-atc');
        var ppsFreqClass = isPlpPlans ? ' pps-frequency-field' : '';

        if (currentGroups) {
          var isOneOption = currentVariant.selling_plan_allocations.length == 1;
          selectedName = selectedName.trim();          
          
          html = isPlpPlans ? `
            <div class="pps-deliver-block">
              <span class="pps-field-label">Deliver every</span>
              <div class="field no-label` + ppsFreqClass + `"><select id="frequency-` + currentVariant.id + `" class="` + (enabled ? `enabled` : ``) + (isOneOption ? ` hide` : ``) + `" ` + (enabled ? `` : `disabled="disabled"`) + `>
          ` : `
            <div class="option-description flex">
              <svg aria-hidden="true" tabindex="-1" class="icon icon-loop" viewBox="0 0 32 32"><path class="stroke-fill" d="M25.1,9.8l6.3-4.3.6,7.6ZM0,18.9l.6,7.6,6.3-4.3Z"/><path d="M3.7,7.6a14.9,14.9,0,0,1,24.6,0M3.7,24.4a14.9,14.9,0,0,0,24.6,0"/></svg>
              <span class="flex-1 option-description-text"></span>
            </div>
            <div class="field no-label` + ppsFreqClass + `"><select id="frequency-` + currentVariant.id + `" class="` + (enabled ? `enabled` : ``) + (isOneOption ? ` hide` : ``) + `" ` + (enabled ? `` : `disabled="disabled"`) + `>
          `;
          
          // Sort to ensure groups without Prepaid come first
          var sortedGroups = currentGroups.sort((a, b) => {
            const aIsPrepaid = a.name.includes("Prepaid");
            const bIsPrepaid = b.name.includes("Prepaid");
            return aIsPrepaid - bIsPrepaid;
          });

          // Iterate over all groups to gather selling plans
          // First, use the provided selectedPlanId if available (preserves user selection)
          var defaultPlanId = null;
          var finalSelectedPlanId = null;
          
          // If a plan ID was provided, use it directly (preserves user's manual selection)
          if (selectedPlanId && selectedPlanId != '') {
            finalSelectedPlanId = selectedPlanId;
          }
          // Otherwise, try to match by selectedName (plan name or display text)
          else if (selectedName && selectedName != '') {
            sortedGroups.forEach((group) => {
              group.selling_plans.forEach((plan) => {
                var planNameTrimmed = plan.name.trim();
                var optionValue = plan.name.replace("Delivered every", "").trim();
                // Match by full name or by display text
                if (selectedName == planNameTrimmed || selectedName == optionValue || 
                    selectedName.toLowerCase() == planNameTrimmed.toLowerCase() ||
                    selectedName.toLowerCase() == optionValue.toLowerCase()) {
                  finalSelectedPlanId = plan.id;
                }
              });
            });
          }
          
          // If no match found and no selectedName/selectedPlanId, find 30-day plan as default
          if (!finalSelectedPlanId && (!selectedName || selectedName == '') && (!selectedPlanId || selectedPlanId == '')) {
            sortedGroups.forEach((group) => {
              group.selling_plans.forEach((plan) => {
                var planName = plan.name.toLowerCase();
                var planOption = plan.options[0]?.value?.toLowerCase() || '';
                if ((planName.includes('30') || planOption.includes('30') || planName.includes('thirty') || planOption.includes('thirty')) &&
                    !planName.includes('60') && !planName.includes('90') && !planName.includes('120') &&
                    !planOption.includes('60') && !planOption.includes('90') && !planOption.includes('120')) {
                  defaultPlanId = plan.id;
                  finalSelectedPlanId = plan.id;
                }
              });
            });
          }
          
          sortedGroups.forEach((group) => {           
            group.selling_plans.forEach((plan) => {
              //var optionValue = plan.options[0].value;
              var optionValue = plan.name.replace("Delivered every", "");
              if (optionValue == 'month') {
                optionValue = '1 month';
              }
              var isSelected = (finalSelectedPlanId && plan.id == finalSelectedPlanId) || 
                               (defaultPlanId && plan.id == defaultPlanId && !finalSelectedPlanId);
              html += `<option value="${plan.id}" ` + (isSelected ? `selected="selected"` : ``) + `>${optionValue}</option>`;
            });
          });

          //Update price and discount to default selling plan (prefer 30-day plan)
          // First, try to find a 30-day plan
          var thirtyDayPlan = null;
          sortedGroups.forEach((group) => {
            group.selling_plans.forEach((plan) => {
              var planName = plan.name.toLowerCase();
              var planOption = plan.options[0]?.value?.toLowerCase() || '';
              if ((planName.includes('30') || planOption.includes('30') || planName.includes('thirty') || planOption.includes('thirty')) &&
                  !planName.includes('60') && !planName.includes('90') && !planName.includes('120') &&
                  !planOption.includes('60') && !planOption.includes('90') && !planOption.includes('120')) {
                var allocation = currentVariant.selling_plan_allocations.find(x => x.selling_plan_id == plan.id);
                if (allocation) {
                  thirtyDayPlan = allocation;
                }
              }
            });
          });
          
          // Use 30-day plan if found, otherwise use first available plan
          var price;
          if (thirtyDayPlan) {
            price = thirtyDayPlan.price;
          } else {
            price = currentVariant.selling_plan_allocations.filter(spg => spg.selling_plan_group_id == currentGroups[0].id)[0].price;
          }
          var priceLbl = this.querySelector('.subscription .option-price .final');
          var compareLbl = this.querySelector('.subscription .option-price .compare');
          var qty = this.getSubscribeQuantity();
          if (compareLbl) compareLbl.innerHTML = $s.formatMoney(currentVariant.price * qty).replace('.00', '');
          if (priceLbl) priceLbl.innerHTML = $s.formatMoney(price * qty).replace('.00', '');

          html += `</select><svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"></path></svg></div>` + (isPlpPlans ? `</div>` : ``);

          if (isOneOption) {
            html += `<div class="selling-plan-name">${currentGroups[0].selling_plans[0].name}</div>`;
          }
        }
        return html;
    }

    getCurrentPlan() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if(currentVariant) {
        return currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==this.input.value);
      }
      return false;
    }

    getCurrentGroup() {
      var planId = this.input && this.input.value;
      if (planId) {
        var fromPlan = this.sellingPlanGroups.find(function (g) {
          return g.selling_plans && g.selling_plans.some(function (p) {
            return String(p.id) === String(planId);
          });
        });
        if (fromPlan && !(fromPlan.name || '').includes('Prepaid')) return fromPlan;
      }
      var checkedInput = this.querySelector('[name="purchase_option"]:checked');
      if (!checkedInput) {
        return null;
      }
      var groupId = checkedInput.value;
      //Filter SPGs that aren't from the current app
      return this.sellingPlanGroups.find(g=>g.id==groupId);
    }
    getUpdateInfo() {
      var optionDiscount = this.querySelector('.subscription .option-discount');
      var optionDiscountInfo = this.querySelector('.option-discount-info');
      if (!optionDiscount || !optionDiscountInfo) return;
      var m = String(optionDiscount.textContent || '').match(/(\d+(?:\.\d+)?)\s*%/);
      optionDiscountInfo.textContent = m ? m[1] + '%' : '';
    }
  }
  customElements.define('product-selling-plan', ProductSellingPlan);
}
